<template>
  <div class="container">
    <div id="div_banner" class="banner1">
      <img src="../../assets/zhaoxian.png" alt="招贤纳士">
      <div>
        <p>招贤纳士</p>
        <span>Recruitment</span>
      </div>
<!--      <img  v-if="imgUrl"  :src="imgUrl"  alt="招贤纳士" height="190">-->
    </div>
    <div class="j1">
      <div class="box">
        <div id="talent_concept" class="title">
          <h2>人才理念</h2>
          <h3>TALENT CONCEPT</h3>
        </div>
        <div class="j1_main clearfix">
          <div class="text fl">
            <h1>{{TalentConceptList.fname}}</h1>
            <h2>Talent concept</h2>
            <div id="div_talentIdea" class="wrap">
              <div v-html="TalentConceptList.fcontent"></div><br>
            </div>
          </div>
          <div class="pic_box fr">
            <img src="../../assets/20170406112203_5672.jpg" alt=""></div>
        </div>
      </div>
    </div>
    <div class="sj1">
      <div class="box">
        <div id="social_recruitment" class="title">
          <h2>社会招聘</h2>
          <h3>SOCIAL RECRUITMENT</h3>
        </div>
        <div id="div_job1" class="s1_main">
          <div class="s1_list" v-for="item in EmploysData1">
            <div class="top1" headerindex="0h">
              <span class="accordprefix"></span>{{item.frecruitmentPost}}
              <span class="accordsuffix"></span>
            </div>
            <div class="main" contentindex="0c" style="display: none;">
              <div class="two">
                <div class="wrap" v-html="item.fjobContent">
                </div>
                <div class="wrap" v-html="item.fjobRequirements">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <h2>应届招聘</h2>
      <h3>FRESH RECRUITMENT</h3>
    </div>
<!--    <div id="fresh_recruitment" class="baner2">-->
<!--      <img src="../../assets/61.jpg" alt="">-->
<!--    </div>-->
    <div class="sj1">
      <div class="box">
        <div id="div_job2" class="s1_main">
          <div class="s1_list" v-for="item in EmploysData2">
            <div class="top1" headerindex="5h">
              <span class="accordprefix"></span>{{item.frecruitmentPost}}
              <span class="accordsuffix"></span>
            </div>
            <div class="main" contentindex="5c" style="display: none;">
              <div class="two">
                <div class="wrap" v-html="item.fjobContent">
                </div>
                <div class="wrap" v-html="item.fjobRequirements">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from '../../../static/js/commonAxios'
    export default {
      name: "employ",
      data(){
        return{
          EmploysData1:[],
          EmploysData2:[],
          TalentConceptList:'',
          imgUrl:'',//头部图
          baseUrl:'',
        }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
        this.getbar()
        this.getEmploysData()
        this.getTalentConceptList()
      },
      methods:{
        getbar(){
          axios.get('/api/bar').then((res) => {
            if(res.data.success){
              let item=res.data.items
              item.forEach(arr=>{
                if(arr.fbar==='招贤纳士'){
                  this.imgUrl = this.baseUrl + arr.fbarUrl
                }
              })
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        // 获取招聘信息
        getEmploysData(){
          axios.get('/api/recruitList').then((res) => {
            if(res.data.success){
              let Sarr = []
              let Yarr = []
              if(res.data.items){
              res.data.items.forEach((ele) => {
                if(ele.frecruitType ==='S'){
                  Sarr.push(ele)
                }else {
                  Yarr.push(ele)
                }
              })
              }
              this.EmploysData1 = Sarr
              this.EmploysData2 = Yarr
              this.$nextTick(()=>{
                $(document).ready(function () {
                  $(".nav li:nth-child(5)").find("a").addClass("active");
                });
                $(function () {
                  $(".s1_list .top1").focus(function () { this.blur(); });
                })
                ddaccordion.init({
                  headerclass: "top1",  //标题
                  contentclass: "main", //内容
                  revealtype: "click",
                  mouseoverdelay: 0,
                  collapseprev: true,
                  defaultexpanded: [0], //默认展开第几个,从0开始
                  onemustopen: false,
                  animatedefault: false,
                  persiststate: true, //默认开启：false
                  toggleclass: ["", "active"],//点击过后样式
                  togglehtml: ["suffix", ""],
                  oninit: function (headers, expandedindices) {
                  },
                  onopenclose: function (header, index, state, isuseractivated) {
                  }
                })
              })
              console.log(this.EmploysData2);
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        // 获取人才理念数据
        getTalentConceptList(){
          axios.get('/api/talentConceptList').then((res) => {
            if(res.data.success){
              this.TalentConceptList = res.data.items?res.data.items[0]:''
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
      }
    }
</script>

<style scoped>
  .title{
    text-align: center;
    background: url(../../assets/2.png) no-repeat center 15px #fff;
  }
  .title h2{
    font-size: 30px;
    color: #333333;
  }
  .title h3{
    font-size: 14px;
    color: #666666;
    margin-top: 10px;
  }
  .j1{
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
    background: #f7f7f7
  }
  .j1 .j1_main{
    width: 100%;
    margin-top: 60px;
  }
  .j1 .j1_main .text{
    width: 100%;
    width: 570px;
  }
  .j1 .j1_main .text h1{
    font-size: 30px;
    color: #333;
    margin-bottom: 10px;
    padding-top: 20px;
    background: url(../../assets/60.jpg) no-repeat left top;
  }
  .j1 .j1_main .text h2{
    color: #999;
    font-size: 24px;
    font-weight: bold;
    font-style: italic;
  }
  .j1 .j1_main .text div{
    margin-top: 10px;
    padding-left: 20px;
    line-height: 30px;
    font-style: 14px;
    color: #333;
  }
  .j1 .j1_main .text .wrap div{
    background: url(../../assets/68.jpg) left center repeat-y;
  }
  .j1 .j1_main .pic_box{
    position: relative;
  }
  .j1 .j1_main .pic_box:before{
    content: "";
    display: block;
    border-top: 2px solid #8ec31f;
    border-bottom: 2px solid #8ec31f;
    position: absolute;
    top: -2px;
    bottom: -2px;
    left: -2px;
    right: -2px;
    z-index: 1000;
    transform: scale(0,1);
    -ms-transform: scale(0,1);
    -moz-transform: scale(0,1);
    -webkit-transform: scale(0,1);
    -o-transform: scale(0,1);

    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .j1 .j1_main .pic_box:hover:before{
    transform: scale(1,1);
    -ms-transform: scale(1,1);
    -moz-transform: scale(1,1);
    -webkit-transform: scale(1,1);
    -o-transform: scale(1,1);
  }

  .j1 .j1_main .pic_box:hover:after{
    transform: scale(1,1);
    -ms-transform: scale(1,1);
    -moz-transform: scale(1,1);
    -webkit-transform: scale(1,1);
    -o-transform: scale(1,1);
  }
  .j1 .j1_main .pic_box:after{
    content: "";
    display: block;
    border-left: 2px solid #8ec31f;
    border-right: 2px solid #8ec31f;
    position: absolute;

    top: -2px;
    bottom: -2px;
    left: -2px;
    right: -2px;

    transform: scale(1,0);
    -ms-transform: scale(1,0);
    -moz-transform: scale(1,0);
    -webkit-transform: scale(1,0);
    -o-transform: scale(1,0);
    transition: all .8s;
    -moz-transition: all .8s; /* Firefox 4 */
    -webkit-transition: all .8s; /* Safari 和 Chrome */
    -o-transition: all .8s; /* Opera */
  }
  .j1 .j1_main .pic_box:before{}
  .sj1{
    width: 100%;
    padding-top: 1px;
    padding-bottom: 65px;
    background: #fff
  }
  .sj1 .s1_main{
    width: 100%;
    margin-top: 60px;
  }
  .sj1 .s1_main .s1_list{
    width: 100%;
    margin-bottom: 10px;
  }
  .sj1 .s1_main .s1_list .top1{
    width: 1140px;
    padding-left: 60px;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color:#333;
    background: url(../../assets/52.png) no-repeat 1140px center #f7f7f7;
  }
  .sj1 .s1_main .s1_list .active{
    background: url(../../assets/53.png) no-repeat 1140px center #8ec31f;
    color: #fff;
  }
  .sj1 .s1_main .s1_list .main{
    width: 1080px;
    padding: 30px 60px;
    background: #f7f7f7
  }
  .sj1 .s1_main .s1_list .main .one{
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ccc
  }
  .sj1 .s1_main .s1_list .main .one li{
    width: 360px;
    line-height: 30px;
    float: left;
    font-size: 14px;
    color: #da251d;
  }
  .sj1 .s1_main .s1_list .main .one li span{
    color: #666;
    margin-left: 20px;
  }
  .sj1 .s1_main .s1_list .main .two{

  }
  .sj1 .s1_main .s1_list .main .two .wrap{
    width: 100%;
    margin-bottom: 25px;
  }
  .sj1 .s1_main .s1_list .main .two .wrap h2{
    color: #333;
    font-weight: bold;
    font-size: 14px;
    line-height: 30px;
  }
  .sj1 .s1_main .s1_list .main .two .wrap div{
    font-size: 14px;
    color: #666;
    line-height: 30px;
  }
  .sj1 .s1_main .s1_list .main .two h3{
    color: #da251d;
    font-size: 14px;
    line-height: 30px;
  }

  .baner2{
    width: 1920px;
    height: 200px;
    position: relative;
    left: 50%;
    margin-left: -960px;
  }
  @media screen and (max-width: 1024px){
    .sj1 .s1_main .s1_list .top1 {
      width: 95%;
      padding-left: 5%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/employs/employs.vue